import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PrintNode_ds_get_scalesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { entity?: { type: string, id: string }, full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, name?: string, computer_id?: string, capture?: { micrograms?: number, captured_on?: string }, device_number?: number, computer?: { id?: number, name?: string } }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { entity?: { type: string, id: string }, full_text_search?: string, $keys: string[] }): Promise<{ result?: { id?: string, name?: string, computer_id?: string, capture?: { micrograms?: number, captured_on?: string }, device_number?: number, computer?: { id?: number, name?: string } }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      entity?: { type: string, id: string }, full_text_search?: string    }) {
      return false;
    }
}
